import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicHomeComponent } from '../public/public-home/public-home.component';
import { HomeComponent } from '../modules/student/home/home.component';
import { AuthGuard } from '../modules/auth/services/auth-guard.service';
import { VideoDetailsComponent } from '../modules/student/video/video-details/video-details.component';
import { VideoLibraryComponent } from '../modules/student/video/video-library/video-library.component';
import { PricingComponent } from '../public/pricing/pricing.component';
import { ArticlesComponent } from '../public/articles/articles.component';
import { AuthContainerComponent } from '../modules/auth/auth-container/auth-container.component';
import { SearchResultComponent } from '../public/search/search-result/search-result.component';
import { PaymentComponent } from '../modules/student/payment/payment.component';
import { PaymentReceiptComponent } from '../modules/student/payment/payment-receipt/payment-receipt.component';

const routes: Routes = [
  {path:'',component : PublicHomeComponent,pathMatch:'full'},
  {path:'auth',component : AuthContainerComponent},
  {path:'home', canActivate : [AuthGuard],component : HomeComponent},
  {path:'video/:video_id',component : VideoDetailsComponent},
  {path:'video-library',component : VideoLibraryComponent},
  {path:'pricing',component : PricingComponent},
  {path:'articles',component : ArticlesComponent},
  {path:'search',component : SearchResultComponent},
  {path:'payment/:plan_id',component : PaymentComponent},
  {path:'payment-receipt',component : PaymentReceiptComponent},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
